import React from "react";
import LayoutCol3R from "../../common/layouts/LayoutCol3R";
import Categories from "../Categories/Categories";
import ItemList from "./ItemList/ItemList";

export default function Shop() {
  return (
    <LayoutCol3R left={<Categories/>} right={<ItemList/>}/>
  )
}